export enum NoDataState {
  notAvailable = 'notAvailable',
  noData = 'noData',
  nothingHere = 'nothingHere'
}
